import { pickBy } from 'lodash';
import getProjectIdFromURL from 'app/core/utils/getProjectIdFromURL';
import store from 'app/store/index';
export const getEpisodes = (state) => {
    if (!state)
        state = store.getState();
    return pickBy(state.assets.resources, (asset) => asset.assetType === 'ep' && asset.project === getProjectIdFromURL());
};
